/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { BookmarkManufacturersDTO } from './BookmarkManufacturersDTO';
import type { Company } from './Company';
import type { CurrencyEnum } from './CurrencyEnum';
import type { FileRequest } from './FileRequest';
import type { Languages } from './Languages';
import type { MaterialInput } from './MaterialInput';
import type { ProjectPartRequest } from './ProjectPartRequest';
import type { SelectedManufacturerRequest } from './SelectedManufacturerRequest';

export type ProjectRequest = {
  title: string;
  deadline: string;
  /**
   * The languages of the project. 2 letters (en, de, it...) defaults to ['en'].
   */
  languages: Array<Languages>;
  /**
   * The reason why buyer is creating project. This is an enum.
   */
  reasonForRequest: ProjectRequest.reasonForRequest;
  /**
   * Is the file protected by NDA. Boolean.
   */
  isNdaProtected: boolean;
  /**
   * Is the file private and not present in the feed. Boolean.
   */
  isPrivate: boolean;
  deliveryDate: string | null;
  /**
   * External Id of the Project (optional)
   */
  projectId: string | null;
  note: string | null;
  incoterms: ProjectRequest.incoterms | null;
  /**
   * Currencies accepted for quotes
   */
  currencies: Array<CurrencyEnum>;
  parts: Array<ProjectPartRequest>;
  selectedManufacturers: Array<SelectedManufacturerRequest>;
  additionalFiles: Array<FileRequest>;
  /**
   * The IDs of the required certifications
   */
  certifications: Array<string>;
  /**
   * The materials user has selected for the project in search
   */
  materials: Array<MaterialInput> | null;
  /**
   * Tender area for the project
   */
  tenderArea: Array<string>;
  /**
   * Publish in behalf of. Company
   */
  publishAs: Company | null;
  ndaFile: FileRequest;
  /**
   * Blocked manufacturers for the project
   */
  blockedManufacturers: Array<BookmarkManufacturersDTO> | null;
  isSniping?: boolean;
  mode: ProjectRequest.mode;
};

export namespace ProjectRequest {
  /**
   * The reason why buyer is creating project. This is an enum.
   */
  export enum reasonForRequest {
    BENCHMARKING = 'BENCHMARKING',
    NEW_PRODUCT = 'NEW_PRODUCT',
    SECOND_SOURCE = 'SECOND_SOURCE',
    SUPPLIER_FAILURE = 'SUPPLIER_FAILURE',
  }

  export enum incoterms {
    CFR = 'CFR',
    CIF = 'CIF',
    CIP = 'CIP',
    CPT = 'CPT',
    DAP = 'DAP',
    DAT = 'DAT',
    DDP = 'DDP',
    DPU = 'DPU',
    EXW = 'EXW',
    FAS = 'FAS',
    FCA = 'FCA',
    FOB = 'FOB',
  }

  export enum mode {
    SINGLE_PARTS = 'single_parts',
    ASSEMBLIES = 'assemblies',
  }
}
